import { formatCurrencyFromMicros, formatDecimal, formatInteger, formatPlatform, formatRoas } from '../constants';

export function PlatformBreakdown({ platformTotals = [] }) {
  return (
    <section className="rounded-2xl border border-mystic-500 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-lynch-500">Platform Mix</p>
          <h2 className="mt-2 text-lg font-semibold text-black-pearl-500">Spend split by ad network</h2>
        </div>
      </div>
      {platformTotals.length === 0 ? (
        <p className="mt-6 text-sm text-lynch-500">No platform totals are available for the selected range yet.</p>
      ) : (
        <div className="mt-6 grid gap-4 md:grid-cols-2">
          {platformTotals.map((platform) => (
            <article key={platform.platform} className="rounded-xl border border-solitude-500 p-4">
              <p className="text-sm font-semibold text-black-pearl-500">{formatPlatform(platform.platform)}</p>
              <dl className="mt-4 grid gap-3 sm:grid-cols-4">
                <Metric label="Spend" value={formatCurrencyFromMicros(platform.spendMicros)} />
                <Metric label="Clicks" value={formatInteger(platform.clicks)} />
                <Metric label="Conv." value={formatDecimal(platform.conversions)} />
                <Metric label="ROAS" value={formatRoas(platform.roas)} />
              </dl>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

function Metric({ label, value }) {
  return (
    <div>
      <dt className="text-[11px] font-semibold uppercase tracking-[0.12em] text-lynch-500">{label}</dt>
      <dd className="mt-2 text-sm font-medium text-black-pearl-500">{value}</dd>
    </div>
  );
}
